import React, { useState } from "react";

const TagsCheckboxForm = ({ audienceTags, userTags, onTagsSaved }) => {
    const [selectedTags, setSelectedTags] = useState(userTags ? userTags.map(tag => tag.id) : []);
    const [isSaving, setIsSaving] = useState(false);

    const handleCheckboxChange = (tagId) => {
        setSelectedTags((prevSelected) =>
            prevSelected.includes(tagId)
                ? prevSelected.filter((id) => id !== tagId)
                : [...prevSelected, tagId],
        );
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSaving(true);

        const form = e.currentTarget;
        const formData = new FormData(form);

        let selectedTags = [];

        for (const value of formData.values()) {
            selectedTags.push(value);
        }

        const audienceTagIds = audienceTags.map(tag => tag.id);

        const payload = {
            method: "POST",
            credentials: "include",
            headers: new Headers({
                "Content-Type": "application/x-www-form-urlencoded",
            }),
            body: new URLSearchParams({
                audience_tags: audienceTagIds,
                new_tags: selectedTags,
                action: "save_preferences",
            }),
        };

        const response = await fetch(ajax_params.ajax_url, payload);
        setIsSaving(false);

        if (!response.ok) {
            console.error('Failed to save preferences:', response.status, response.statusText);
            window.alert('There was a problem saving your preferences. Please try again.');
            return;
        }

        // Notify parent to refresh user/tags
        if (typeof onTagsSaved === 'function') {
            onTagsSaved();
        }
    };

    return (
        <>
            <h2 className="section__heading">Picked for you</h2>

            <p className="type-body-xl">
                To see our recommendations picked for you, save your genre
                preferences:
            </p>

            <form className="highlight-feed__preferences" onSubmit={handleSubmit}>
                <fieldset>
                    <legend>Save your genre preferences</legend>

                    <p className="">Please select from the options below:</p>

                    <div className="highlight-feed__preferences-checkblock">
                        {audienceTags.map((tag) => (
                            <div key={tag.id} className="">
                                <input
                                    type="checkbox"
                                    id={tag.id}
                                    name="tags[]"
                                    value={tag.id}
                                    checked={selectedTags.includes(tag.id)}
                                    onChange={() => handleCheckboxChange(tag.id)}
                                />

                                <label htmlFor={tag.id}>
                                    {tag.name}
                                </label>
                            </div>
                        ))}
                    </div>
                </fieldset>

                <button className="btn btn--icon btn--black" type="submit" disabled={isSaving}>
                    {isSaving ? "Saving..." : "Save preferences"}
                </button>
            </form>
        </>
    );
};

export default TagsCheckboxForm;
